export const formMixin = {
  methods: {
    validateFile(file, objRule, error) {
      if (!file) return false;

      if (objRule.size.maxSize) {
        if (file.size > objRule.size.maxSize) {
          error[objRule.size.keyError] = objRule.size.message;
          return false;
        }
      }

      if (objRule.size.minSize) {
        if (file.size < objRule.size.minSize) {
          error[objRule.size.keyError] = objRule.size.message;
          return false;
        }
      }

      if (objRule.type.format) {
        let fileName = file.name;
        let formatFile = fileName.split('.').pop();
        let endOfFile = objRule.type.format;
        if (endOfFile.indexOf(formatFile.toLowerCase(), 0) === -1) {
          error[objRule.type.keyError] = objRule.type.message;
          return false;
        }
      }

      return true;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
  }
};

export default formMixin;
